module.exports = __webpack_public_path__ + "static/img/txtbtn_arrow.2f0fe50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/txtbtn_arrow.svg
// module id = /+V5
// module chunks = 10